import { Control } from 'ol/control';

export class LayerSwitcherControl extends Control {
  layers = [];
  overlay;
  visible = false;
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'F';
    button.title = 'Fonds de plan';

    const element = document.createElement('div');
    element.className = 'ol-layer-switcher ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.openPanel.bind(this), false);
  }

  openPanel() {
    if (!this.container) {
      this.createOverlayContainer();
    }
    this.container.classList.remove('non-visible');
  }

  closePanel() {
    this.container.classList.add('non-visible');
  }

  createOverlayContainer() {
    const container = document.createElement('div');
    this.getMap()
      .getLayers()
      .forEach((layer) => {
        if (layer.get('estFondDePlan')) this.layers.push(layer);
      });

    const closeButton = document.createElement('div');
    closeButton.innerHTML = '✖';
    closeButton.classList.add('close-btn');
    closeButton.addEventListener('click', this.closePanel.bind(this));
    container.append(closeButton);

    this.layers.forEach((layer) => {
      const id = layer.get('id');
      const wrapper = document.createElement('div');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'layer';
      radio.value = id;
      radio.id = id;
      radio.checked = layer.getVisible();

      radio.addEventListener('change', this.onRadioChange.bind(this));
      const label = document.createElement('label');
      label.textContent = layer.get('titre');
      label.for = id;
      wrapper.classList.add('layer');
      wrapper.append(radio);
      wrapper.append(label);
      container.append(wrapper);
    });
    container.classList.add('layer-switcher-container', 'non-visible');
    this.container = container;
    this.getMap().getViewport().append(this.container);
  }

  onRadioChange(event) {
    const id = event.target.value;
    this.layers.forEach((layer) => layer.setVisible(layer.get('id') === id));
  }
}
